import { render, staticRenderFns } from "./ElCollapse.vue?vue&type=template&id=013e07fd"
import script from "./ElCollapse.vue?vue&type=script&lang=js"
export * from "./ElCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports